import React, { useContext } from "react";
import { TScreen } from "api/type";

// Import Contexts
import ScreenContext from "contexts/screen";

// Import Components
import {
  BodyScanInstructions,
  PrimaryButton,
  TitleBar,
} from "components/index";

type ScreenScanInstructionProps = {};

const ScreenScanInstruction: React.FC<ScreenScanInstructionProps> = () => {
  const setScreen = useContext(ScreenContext)[1];

  return (
    <div className="screen-container">
      <TitleBar
        name={"Scan Instruction"}
        onClickBackButton={() => setScreen(TScreen.SELECT_UPLOAD_TYPE_SCREEN)}
      />
      <BodyScanInstructions />
      <PrimaryButton
        text={"Continue"}
        fullWidth
        onClick={() => setScreen(TScreen.BODY_SCAN_SCREEN)}
      />
    </div>
  );
};

export default ScreenScanInstruction;
